import { FlightTextInput } from '@flybits/design-system';
import React, { useState } from 'react';
import { FieldsConfig } from 'src/model/connectors/connectors';
import './InputPreview.scss';

const InputPreview = (props: FieldsConfig) => {
  const { name, onChangeValue, configField } = props;
  const [value, setValue] = useState(configField ? configField[2]?.configVal : '');
  const handleChange = (e: any) => {
    setValue(e.target.value);
    typeof onChangeValue === 'function' &&
      onChangeValue({
        field: [configField[0], configField[1]],
        data: { ...configField[2], configVal: e.target.value },
      });
  };
  return (
    <div className="input-preview">
      <label htmlFor={props.name}>{props.viewName}</label>
      <div>
        <FlightTextInput
          placeholderText=""
          theme="light"
          width="400px"
          type="text"
          name={name}
          value={value}
          labelId={props.name}
          onChange={handleChange}
          data-lpignore="true"
        />
      </div>
    </div>
  );
};
export default InputPreview;
